const databaseKeys = {
  all: ['databases'],
  available: ['databases', 'available']
};

export default databaseKeys;
